import React, { useMemo } from "react";
import BarChart from "components/charts/BarChart";

const CAChart = ({ yearlyData }) => {
  const chartSeries = useMemo(() => {
    return [
      {
        name: "Quantité",
        data: yearlyData.map((d) => Number(d.sumOfQuantity || 0)),
      },
      {
        name: "Montant HT",
        data: yearlyData.map((d) => Number(d.sumOfAmount || 0)),
      },
    ];
  }, [yearlyData]);

  const chartOptions = useMemo(() => {
    return {
      chart: { type: "bar", toolbar: { show: false } },
      xaxis: {
        categories: yearlyData.map((d) => d.year),
        labels: { style: { fontSize: "12px" } },
        title: { text: "Année" },
      },
      yaxis: [
        {
          labels: { formatter: (v) => new Intl.NumberFormat("en-EN").format(v) },
          title: { text: "Quantité" },
        },
        {
          opposite: true,
          labels: { formatter: (v) => new Intl.NumberFormat("en-EN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v) },
          title: { text: "Montant HT (DH)" },
        },
      ],
      plotOptions: { bar: { horizontal: false, columnWidth: "55%", borderRadius: 4 } },
      dataLabels: {
        enabled: true,
        formatter: (val, opts) => {
          const name = opts.w.config.series[opts.seriesIndex].name;
          if (name === "Montant HT") {
            return new Intl.NumberFormat("en-EN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val) + " DH";
          }
          return new Intl.NumberFormat("en-EN").format(val);
        },
        style: { fontSize: "12px", fontWeight: "bold", colors: ["#000000"] },
      },
      tooltip: {
        y: {
          formatter: (val, opts) => {
            const name = opts?.w?.config?.series?.[opts.seriesIndex]?.name;
            if (name === "Montant HT") {
              return new Intl.NumberFormat("en-EN", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val) + " DH";
            }
            return new Intl.NumberFormat("en-EN").format(val);
          },
        },
      },
      colors: ["#2563eb", "#16a34a"],
      grid: { strokeDashArray: 4 },
      legend: { position: "top", horizontalAlign: "right" },
    };
  }, [yearlyData]);

  return (
    <BarChart chartData={chartSeries} chartOptions={chartOptions} width="100%" height={520} />
  );
};

export default CAChart;
